import React from "react";

const SearchBox = ({defaultValue, onSearch, onKeyPress, className, placeholder}) => {
    let searchInput;
    return <form className={`search-form ${className}`} onSubmit={e => {
        e.preventDefault();
        onSearch(searchInput.value || null)
    }}>
        <input className="search-form__input"
               ref={ref => searchInput = ref} type="text"
               title={placeholder}
               defaultValue={defaultValue}
               placeholder={placeholder}
               onChange={(e) =>onKeyPress && onKeyPress(e.target.value || null)}
        />
        <button className="search-form__submit" title="Search"><span className="glyphicon glyphicon-search"/></button>
        <button className="search-form__clear" title="Clear" onClick={e=> {
            e.preventDefault();
            searchInput.value = '';
            onSearch(null)
        }
        }><span className="glyphicon glyphicon-remove"/></button>
    </form>
};

export default SearchBox
